import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const ActionRow = ({ onBack, onSubmit, label, disabled, isLoading }) => (
  <div className="flex gap-2.5 items-start w-full">
    {onBack && (
      <button
        type="button"
        onClick={onBack}
        className="shrink-0 w-[40px] h-[40px] md:w-[54px] md:h-[54px] rounded-[8px] md:rounded-[12px] bg-primary border-2 border-black flex items-center justify-center text-white hover:bg-primary/90 transition-colors"
      >
        <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" />
      </button>
    )}
    <Button
      type={onSubmit ? "button" : "submit"}
      onClick={onSubmit}
      className="flex-1 md:h-[54px] md:text-[24px] md:rounded-[14px]"
      size="sm"
      variant={disabled ? "disabled" : "default"}
      disabled={disabled || isLoading}
    >
      {isLoading ? "Bitte warte..." : label}
    </Button>
  </div>
);

export default ActionRow;
